export default __webpack_public_path__ + "static/media/allianceFrida.726ef9d2.png";